export enum UserRole {
    Partner = "Partner",
    Admin = "Admin",
    SiteAdmin = "SiteAdmin"
}
